/* NEWS / LOOK BOOK 用の軽量スライダー（絵コンテ 4・5）。
   Prestige の scroll-carousel は「中央の1枚にだけ文字」「左右を27%ずつ覗かせる」が
   できないので自前で持つ。
   - centered 属性あり: アクティブなスライドを中央に置く（NEWS の peek）
   - centered 属性なし: 左詰めで --rb-per-view 枚ずつ見せる（LOOK BOOK） */
if (!customElements.get('rb-slider')) {
  class RbSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rb-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.index = Math.min(parseInt(this.dataset.start || '0', 10), this.slides.length - 1);

      this.querySelectorAll('[data-rb-prev]').forEach((b) => b.addEventListener('click', () => this.go(this.index - 1)));
      this.querySelectorAll('[data-rb-next]').forEach((b) => b.addEventListener('click', () => this.go(this.index + 1)));

      let startX = null;
      this.track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      this.track.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
      });

      this.onResize = () => this.update();
      window.addEventListener('resize', this.onResize);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    perView() {
      const v = parseFloat(getComputedStyle(this).getPropertyValue('--rb-per-view'));
      return v > 0 ? v : 1;
    }

    maxIndex() {
      if (this.hasAttribute('centered')) return this.slides.length - 1;
      return Math.max(0, this.slides.length - Math.floor(this.perView()));
    }

    go(i) {
      this.index = Math.max(0, Math.min(i, this.maxIndex()));
      this.update();
    }

    update() {
      if (!this.slides.length) return;
      this.index = Math.min(this.index, this.maxIndex());
      const first = this.slides[0];
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = first.getBoundingClientRect().width + gap;
      let offset = -this.index * step;
      if (this.hasAttribute('centered')) offset += (this.track.clientWidth - first.getBoundingClientRect().width) / 2;
      this.track.style.transform = `translateX(${offset}px)`;

      this.slides.forEach((s, i) => {
        const active = i === this.index;
        s.classList.toggle('is-active', active);
        s.classList.toggle('is-before', i < this.index);
        s.classList.toggle('is-after', i > this.index);
        s.setAttribute('aria-hidden', this.hasAttribute('centered') ? String(!active) : 'false');
      });

      // 画像の高さ（矢印を写真の上下中央に置くため）とドット
      const media = first.querySelector('img, svg');
      if (media) this.style.setProperty('--rb-media-h', `${media.getBoundingClientRect().height}px`);
      const max = this.maxIndex();
      const dots = this.querySelector('[data-rb-dots]');
      if (dots) {
        if (dots.children.length !== max + 1) {
          dots.replaceChildren(...Array.from({ length: max + 1 }, (_, i) => {
            const d = document.createElement('button');
            d.type = 'button';
            d.className = 'rb-hero__dot';
            d.setAttribute('aria-label', `${i + 1}枚目`);
            d.addEventListener('click', () => this.go(i));
            return d;
          }));
        }
        Array.from(dots.children).forEach((d, i) => d.setAttribute('aria-current', String(i === this.index)));
      }
      this.toggleAttribute('data-static', max === 0);
      this.querySelectorAll('[data-rb-prev]').forEach((b) => { b.disabled = this.index === 0; });
      this.querySelectorAll('[data-rb-next]').forEach((b) => { b.disabled = this.index >= max; });
    }
  }
  customElements.define('rb-slider', RbSlider);
}
